import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getQueryData } from "src/helpers/helpers";
import useFetchAsync from "src/hooks/useFetchAsync";
import { deleteReq, useGet, usePatch, usePost } from "src/http-clients/clients";
import { getActiveStoreId } from "src/redux/selectors/app";

export const useCreateWithdraw = () => {
  const activeStore = useSelector(getActiveStoreId);
  return usePost(`/users/${activeStore}/withdraw/create-withdraw`);
};

export const useGetWithdraws = ({
  length,
  page,
  search,
}: {
  length: number;
  page: number;
  search?: string;
}) => {
  const activeStore = useSelector(getActiveStoreId);
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  const data = useGet(`/users/${activeStore}/withdraw/list${queryData}`);
  return data;
};

export const useGetWithdrawData = (expenseId?: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return useGet(
    expenseId ? `/users/${activeStore}/withdraw/${expenseId}` : null
  );
};

export const useUpdateWithdraw = (expenseId?: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return usePatch(
    expenseId ? `/users/${activeStore}/withdraw/${expenseId}` : null
  );
};

export const useDeleteWithdraw = () => {
  const activeStore = useSelector(getActiveStoreId);
  const deleteData = useCallback(
    (expenseId: number) => {
      return deleteReq(`/users/${activeStore}/withdraw/${expenseId}`);
    },
    [activeStore]
  );
  return useFetchAsync(deleteData);
};

export const useGetOpeningAmount = () => {
  const activeStore = useSelector(getActiveStoreId);
  return useGet(`/users/${activeStore}/withdraw/opening-amount`);
};
